/*
* Project: LegalPlace assistant
* File: src/redux/actions/load_ovc.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/
import { setContractName } from './document_state';
import { unloadingWizard } from './loading';
import { LpError } from '../../errors/error';
import { lpSetError } from './lperrors';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';
import ConditionsEvo from '../../logic/condition_evo';
const UPDATE_OVC = 'LOAD_OVC';


function updateOVC(ovc) {
  return {
    type: UPDATE_OVC,
    ovc,
  };
}

function loadOVC(ovc) {
  return dispatch => {
    window.OVC = ovc;
    // console.log(data)
    dispatch(setContractName(window.contractName));
    dispatch({ type: UPDATE_OVC, ovc: ovc });

    // Setting client email

    // set the current section to 0
    if (lpApp.continuity) {
      lpApp.mutex.setMutex('links', true);

      const sectionNb = Number.isNaN(parseInt(lpApp.continuity.section, 10))
        ? 0
        : parseInt(lpApp.continuity.section, 10);

      if (sectionNb > Object.keys(lpApp.indexes.real_sections).length) dispatch({ type: 'SET_SECTION_ID', id: 0 });
      else {
        dispatch({ type: 'SET_SECTION_ID', id: 0});
      }
    } else dispatch({ type: 'SET_SECTION_ID', id: 0 });

    dispatch({ type: 'NOT_LOADING' });
    lpApp.mutex.setMutex('links', true);
    lpApp.indexes.options.loadFromO();
    lpApp.indexes.variables.loadFromO();

    // Executing all conditions after ovc if fully loaded
    ConditionsEvo.execAllConditions();

    dispatch({type: 'UPDATE_SECTIONS_C'});

    dispatch(unloadingWizard());
    dispatch(lpSetError(new LpError(0, 0, '')));
    window.prerenderReady = true;
    window.lpMax = 255;
  }
}

function autosaveLoadOVC(data) {
  // prepare the link
  return (dispatch) => {
    // test validity
    if (data) {
      window.OVC = data;
      dispatch(setContractName(window.contractName));
      dispatch({ type: UPDATE_OVC, ovc: data });
      dispatch({ type: 'NOT_LOADING' });
      lpApp.indexes.options.loadFromO();
      lpApp.indexes.variables.loadFromO();
      dispatch(unloadingWizard());
      // sinon
    }
  };
}

window.loadOVC = loadOVC;

export {
  UPDATE_OVC,
  updateOVC,
  loadOVC,
  autosaveLoadOVC,
};



// WEBPACK FOOTER //
// ./src/redux/actions/load_ovc.js